// Home status transitions: fed <-> starved -> dark. Emits events on change.
import type { DispatchResult } from './dispatch';
import type { SimEvent } from './events';
import type { Balance, World } from './types';

export function updateHomes(
  world: World,
  dispatch: DispatchResult,
  balance: Balance,
  events: SimEvent[],
): void {
  const fill = 1 / balance.failure.outageTicksToDark;
  const recover = 1 / balance.failure.recoveryTicks;
  for (const home of world.homes) {
    if (home.status === 'dark') continue;
    const fed = dispatch.homeFed[home.id] === true;
    if (fed) {
      home.outage = Math.max(0, home.outage - recover);
      if (home.status !== 'fed') {
        home.status = 'fed';
        events.push({ t: 'HomeFed', homeId: home.id });
      }
    } else {
      home.outage = Math.min(1, home.outage + fill);
      if (home.outage >= 1 - 1e-9) {
        home.status = 'dark';
        events.push({ t: 'HomeDark', homeId: home.id });
      } else if (home.status !== 'starved') {
        home.status = 'starved';
        events.push({ t: 'HomeStarved', homeId: home.id });
      }
    }
  }
}

export function countHomes(world: World): {
  total: number;
  fed: number;
  starved: number;
  dark: number;
} {
  const c = { total: 0, fed: 0, starved: 0, dark: 0 };
  for (const h of world.homes) {
    c.total++;
    c[h.status]++;
  }
  return c;
}
